export default __webpack_public_path__ + "locales/sl/Common.json?hash=635267601fa79a0420b682beadcb4589";